import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {
  RequestUpdateCompanySettingDto,
  ResponseGetCompanySettingDto,
  ResponseUpdateCompanySettingDto,
} from "../dto/setting.dto";
import { ResponseData } from "../../nest-responses";

@Injectable()
export class SettingApi {
  private readonly service: string = '';
  private readonly model: string = 'setting';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getCompanySetting(): Observable<ResponseGetCompanySettingDto> {
    const method: string = 'GET';
    const func: string = 'getCompanySetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetCompanySettingDto>(method, url, func, params, body);
  }

  public updateCompanySetting(payload: RequestUpdateCompanySettingDto): Observable<ResponseUpdateCompanySettingDto> {
    const method: string = 'POST';
    const func: string = 'updateCompanySetting';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseUpdateCompanySettingDto>(method, url, params, urlParams, body);
  }

  public attendanceUpload(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'attendanceUpload';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-all-in-one/services/setting.api.ts